//ページトップへTweenMax版 (アンカーにも使える)
var pageTop = function(_option) {
    this.option = {
        id: null,
        duration: 3,
        easing: Power4.easeOut,
        target: 0
    };
    $.extend(this.option, _option);
    var PreventScroll = require('./PreventScroll');
    this.preventScroll = new PreventScroll();

    require('TweenMax');
    require('ScrollToPlugin');
};

pageTop.prototype = {
    init: function() {
        var _this = this;

        $(_this.option.id).on('click', function(e){
            e.preventDefault();
            _this.preventScroll.on();
            _this.goTop();
        });
    },
    goTop: function() {
        var _this = this;
        TweenMax.to(window, _this.option.duration, {
            scrollTo:{
                y:_this.option.target
            },
            ease: _this.option.easing,
            onComplete: function(){
                _this.preventScroll.off();
            }
        });
    }
};

module.exports = pageTop;


/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/pc/assets/js/module/pagetop.js
 **/